import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get, api_delete } from "services/api";
import { SERVICES, NOTES, DONE } from "views/Map/MapPageTypes";
import dayjs from "dayjs";
import { orderCompaniesAndStations } from "helpers/companiesNormalized";

// variables
import * as variables from "components/MapLateralMenu/variable";
import { convertToMapMultiple } from "helpers/convertToMap";

// Filter
const LOAD_COMPANIES = "LOAD_COMPANIES";
const SET_COMPANIES = "SET_COMPANIES";
const CLEAR_MAPS = "CLEAR_MAPS";
const SET_SEARCH = "SET_SEARCH";
const SET_SELECTED_TYPES = "SET_SELECTED_TYPES";
// Filter
const LOAD_UNITS = "LOAD_UNITS";
const SET_UNITS = "SET_UNITS";
const CLEAR_UNITS = "CLEAR_UNITS";
// Units
const SET_SELECTED_UNITS = "SET_SELECTED_UNITS";
const REMOVE_SELECTED_UNIT = "REMOVE_SELECTED_UNIT";
const SET_TABLE_DETAILS = "SET_TABLE_DETAILS";
const REMOVE_TABLE_DETAILS = "REMOVE_TABLE_DETAILS";
// Unit row
const LOAD_ROW_INFO = "LOAD_ROW_INFO";
const SET_ROW_INFO = "SET_ROW_INFO";
const ERROR_ROW_INFO = "ERROR_ROW_INFO";
const SET_ROW_CHECKED = "SET_ROW_CHECKED";

const ERROR_UNITS = "ERROR_UNITS";
const ERROR_COMPANY = "ERROR_COMPANY";
const CLEAR_ERROR = "CLEAR_ERROR";

// Cancel services
const CANCEL_SERVICE = "CANCEL_SERVICE";
const SET_CANCEL_SERVICE = "SET_CANCEL_SERVICE";
const ERROR_CANCEL_SERVICE = "ERROR_CANCEL_SERVICE";

// Menu lateral
const TOGGLE_IS_NOTE = "TOGGLE_IS_NOTE";
const TOGGLE_IS_DOWNWARD = "TOGGLE_IS_DOWNWARD";

const INITIAL_STATE = {
  // table
  units: [],
  causes: [],
  causesMap: [],
  selectedUnits: [],
  tableDetails: [],
  isLoadingUnits: false,
  isOpenDetails: false,
  error: false,
  itemDetail: null,
  isLoadingDetails: false,
  isNote: true,
  errorMessage: "",
  checked: [
    variables.ONTRANSIT,
    variables.CANCEL,
    variables.ORDERS,
    variables.PENDING,
  ],
  // filter
  isLoading: false,
  search: "",
  types: [],
  typesValues: [],
  // Cancel
  isLoadingCancel: false,
  // sort
  isDownward: true,
};

const mapPageReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_COMPANIES:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
      };
    case SET_COMPANIES:
      return {
        ...state,
        companies: payload,
        isLoading: false,
      };
    case CLEAR_MAPS:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: payload,
      };
    case SET_SELECTED_TYPES:
      const values = payload ? payload.map((item) => item.label) : [];
      return {
        ...state,
        types: payload,
        typesValues: values,
      };

    case ERROR_COMPANY:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };

    case LOAD_UNITS:
      return {
        ...state,
        units: [],
        causes: [],
        causesMap: {},
        selectedUnits: [],
        tableDetails: [],
        isOpenDetails: false,
        isLoadingUnits: true,
        error: false,
        errorMessage: "",
      };
    case SET_UNITS:
      return {
        ...state,
        units: payload.units,
        causes: payload.causes,
        causesMap: payload.causesMap,
        isLoadingUnits: false,
        selectedUnits: payload.selectedUnits,
      };
    case CLEAR_UNITS:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case ERROR_UNITS:
      return {
        ...state,
        isLoadingUnits: false,
        error: true,
        errorMessage: payload.message,
      };
    case SET_SELECTED_UNITS:
      return {
        ...state,
        selectedUnits: [...state.selectedUnits, payload],
      };
    case LOAD_ROW_INFO:
      const { unit: idLoad } = payload;
      const unitsLoad = [...state.units];
      const indexLoad = unitsLoad.findIndex((unit) => unit.id === idLoad);

      if (indexLoad !== -1) {
        unitsLoad[indexLoad] = {
          ...unitsLoad[indexLoad],
          isLoading: true,
          error: false,
          errorMessage: "",
        };
      }

      return {
        ...state,
        units: unitsLoad,
        isLoadingDetails: true,
      };
    case SET_ROW_INFO:
      const { id, services, notes, route } = payload;
      const unitsSet = [...state.units];
      const indexRow = unitsSet.findIndex((unit) => unit.id === id);

      if (indexRow !== -1) {
        unitsSet[indexRow] = {
          ...unitsSet[indexRow],
          isLoading: false,
          servicesList: services,
          notesList: notes,
          route,
        };
      }

      const unitItem = unitsSet[indexRow] || null;

      return {
        ...state,
        units: unitsSet,
        itemDetail: unitItem,
        isLoadingDetails: false,
      };
    case ERROR_ROW_INFO:
      const { id: idError } = payload;
      const unitsError = [...state.units];

      const indexError = unitsError.findIndex((unit) => unit.id === idError);

      if (indexError !== -1) {
        unitsError[indexError] = {
          ...unitsError[indexError],
          isLoading: false,
        };
      }
      return {
        ...state,
        units: unitsError,
        isLoadingDetails: false,
        error: true,
        itemDetail: null,
        errorMessage: payload.message,
      };

    case SET_ROW_CHECKED:
      return {
        ...state,
        checked: payload,
      };

    case REMOVE_SELECTED_UNIT:
      const { selectedUnits } = state;
      const newSelectedUnits = [...selectedUnits];
      const index = selectedUnits.indexOf(payload);
      if (index !== -1) {
        newSelectedUnits.splice(index, 1);
      }

      return {
        ...state,
        selectedUnits: newSelectedUnits,
      };

    case SET_TABLE_DETAILS:
      return {
        ...state,
        tableDetails: [payload],
        isOpenDetails: true,
      };
    case REMOVE_TABLE_DETAILS:
      return {
        ...state,
        tableDetails: [],
        isOpenDetails: false,
        itemDetail: null,
        isNote: true,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };

    // CANCEL
    case CANCEL_SERVICE:
      return {
        ...state,

        isLoadingCancel: true,
        error: false,
        errorMessage: "",
      };
    case SET_CANCEL_SERVICE:
      const { idUnit, idToCancel, itemToCancel } = payload;

      const unitsCancel = [...state.units];
      const indexCancelRow = unitsCancel.findIndex(
        (unit) => unit.id === idUnit
      );

      let unitCancelItem = null;
      if (indexCancelRow !== -1) {
        const currentUnit = unitsCancel[indexCancelRow];
        const updatedServicesList = currentUnit.servicesList.map((service) =>
          service.id === idToCancel
            ? { ...service, status: itemToCancel.status }
            : service
        );
        unitCancelItem = { ...currentUnit, servicesList: updatedServicesList };
        unitsCancel[indexCancelRow] = unitCancelItem;
      }
      return {
        ...state,
        units: unitsCancel,
        itemDetail: unitCancelItem,
        isLoadingCancel: false,
      };
    case ERROR_CANCEL_SERVICE:
      return {
        ...state,
        isLoadingCancel: false,
        error: true,
        errorMessage: payload.message,
      };
    case TOGGLE_IS_NOTE:
      return {
        ...state,
        isNote: !state.isNote,
      };
    case TOGGLE_IS_DOWNWARD:
      const sortedUnits = [...state.units];
      sortedUnits.reverse();
      return {
        ...state,
        isDownward: !state.isDownward,
        units: sortedUnits,
      };

    default:
      return state;
  }
};

function getCompanies() {
  return {
    type: LOAD_COMPANIES,
  };
}

function getStations(stations) {
  return {
    type: LOAD_UNITS,
    payload: {
      stations,
    },
  };
}
function getUnitDocuments(unit, date) {
  return {
    type: LOAD_ROW_INFO,
    payload: { unit, date },
  };
}
function cancel(idUnit, id, body) {
  return {
    type: CANCEL_SERVICE,
    payload: {
      idUnit,
      id,
      body,
    },
  };
}
function clearUnits() {
  return {
    type: CLEAR_UNITS,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR,
  };
}
function toggleIsNote() {
  return {
    type: TOGGLE_IS_NOTE,
  };
}
function toggleIsDownward() {
  return {
    type: TOGGLE_IS_DOWNWARD,
  };
}
function removeTableDetails() {
  return {
    type: REMOVE_TABLE_DETAILS,
  };
}
function setRowChecked(checked) {
  return {
    type: SET_ROW_CHECKED,
    payload: checked,
  };
}
function setSelectedTypes(types) {
  return {
    type: SET_SELECTED_TYPES,
    payload: types,
  };
}
function setSearch(search) {
  return {
    type: SET_SEARCH,
    payload: search,
  };
}

function* fetchCompanies() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  try {
    const response = yield call(api_get, url, auth);
    const newCompanies = response ? response.companies : [];

    const orderedCompanies = orderCompaniesAndStations(newCompanies);

    yield put({ type: SET_COMPANIES, payload: orderedCompanies });
  } catch (message) {
    yield put({
      type: ERROR_COMPANY,
      payload: {
        message,
      },
    });
  }
}
function* fetchUnits(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { stations = [] },
  } = action;
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/units/map`;
  const baseUrlCauses = `${process.env.REACT_APP_URL}${PROYECT}/stations/causes`;
  let urlStations = "";
  let urlStationsCauses = "";
  stations.forEach((station, index) => {
    if (index) {
      urlStations = `${urlStations}&idStations=${station}`;
      urlStationsCauses = `${urlStationsCauses}&stations=${station}`;
    } else {
      urlStations = `${urlStations}?idStations=${station}`;
      urlStationsCauses = `${urlStationsCauses}?stations=${station}`;
    }
  });
  const url = `${baseUrl}${urlStations}`;
  const urlCauses = `${baseUrlCauses}${urlStationsCauses}`;

  try {
    const [units, causes] = yield all([
      call(api_get, url, auth),
      call(api_get, urlCauses, auth),
    ]);
    const normalizeUnits = units.map((item) => {
      return {
        ...item,
        UP: dayjs(item.lastComm).format("YYYY-MM-DD HH:MM:DD"),
        total: item.total.toFixed(2),
        isLoading: false,
        error: false,
        errorMessage: "",
        notesList: [],
        servicesList: [],
        route: [],
      };
    });

    normalizeUnits.sort((act, next) => act.number.localeCompare(next.number));
    causes.sort((act, next) => act.name.localeCompare(next.name));
    const causesMap = convertToMapMultiple(causes, "idStation");
    const selectedUnits = units.map((unit) => unit.number);
    yield put({
      type: SET_UNITS,
      payload: { units: normalizeUnits, causes, causesMap, selectedUnits },
    });
  } catch (message) {
    yield put({
      type: ERROR_UNITS,
      payload: {
        message,
      },
    });
  }
}
function* fetchUnitDocuments(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { unit, date },
  } = action;

  const urlNotes = `${process.env.REACT_APP_URL}${PROYECT}/units/${unit}/notes?date=${date}`;
  const urlServices = `${process.env.REACT_APP_URL}${PROYECT}/units/${unit}/services?date=${date}`;
  const urlRouts = `${process.env.REACT_APP_URL}${PROYECT}/units/${unit}/gps?date=${date}`;

  try {
    const notes = yield call(api_get, urlNotes, auth);
    const services = yield call(api_get, urlServices, auth);
    const route = yield call(api_get, urlRouts, auth);

    const notesNormalize = notes
      .map((note) => {
        return { ...note, type: NOTES };
      })
      .sort((act, next) => act.hour.localeCompare(next.hour));
    const servicesNormalize = services
      .filter((service) => service.status !== DONE)
      .map((service) => {
        return { ...service, type: SERVICES };
      })
      .sort((act, next) => act.hour.localeCompare(next.hour));
    const routeNormalize = route
      .map((point) => {
        return { ...point, lat: point.latitude, lng: point.longitude };
      })
      .sort((act, next) => act.date.localeCompare(next.date));

    yield put({
      type: SET_ROW_INFO,
      payload: {
        id: unit,
        services: servicesNormalize,
        notes: notesNormalize,
        route: routeNormalize,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_ROW_INFO,
      payload: {
        id: unit,
        message,
      },
    });
  }
}
function* cancelService(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { idUnit, id, body },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/services/${id}`;
  try {
    const response = yield call(api_delete, url, body, auth);

    yield put({
      type: SET_CANCEL_SERVICE,
      payload: {
        idUnit,
        idToCancel: id,
        itemToCancel: response[0],
      },
    });
  } catch (e) {
    const { data } = e.response;
    let error = "";
    if (e.response.status === 404) {
      error = "Error al enviar la petición.";
    } else {
      error = data ? data.message.error : "Error de datos";
    }
    yield put({
      type: ERROR_CANCEL_SERVICE,
      payload: {
        message: error,
      },
    });
  }
}

function* mapPageSaga() {
  yield takeLatest(LOAD_COMPANIES, fetchCompanies);
  yield takeLatest(LOAD_UNITS, fetchUnits);
  yield takeLatest(LOAD_ROW_INFO, fetchUnitDocuments);
  yield takeLatest(CANCEL_SERVICE, cancelService);
}

export {
  // reducer
  mapPageReducer,
  // actions
  getCompanies,
  getStations,
  getUnitDocuments,
  clearUnits,
  clearError,
  cancel,
  toggleIsNote,
  toggleIsDownward,
  removeTableDetails,
  setRowChecked,
  setSelectedTypes,
  setSearch,
  //sagas
  mapPageSaga,
  // types
  SET_SEARCH,
  SET_SELECTED_UNITS,
  REMOVE_SELECTED_UNIT,
  SET_TABLE_DETAILS,
  REMOVE_TABLE_DETAILS,
};
